module.exports = ".activeProgram {\n  background-color: brown; }\n\n.activeProgramtitle {\n  background-color: black;\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/active-program1/active-program1.component.scss
// module id = ./src/app/allPanels/active-program1/active-program1.component.scss
// module chunks = main